import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import ProductCard from 'containers/cards/Product';
// import Paper from "@mui/material/Paper";
import screenSize from 'ripple/Utils/screenSize';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { useQuery } from '@apollo/client';
import { useRouter } from 'found';
import { GET_PRODUCT_INFO } from '../../../../../schema/apolloQueries/eventDeatilsQueries';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: 'transparent',
    padding: 5,
    boxShadow: 'none',
  },
  gridList: {
    padding: 5,
    flexWrap: 'wrap',
    transform: 'translateZ(0)',
  },
  card: {
    backgroundColor: theme.palette.background.paper,
  },
}));

const ProductGridView = ({ eventId, viewer }) => {
  const { router } = useRouter();
  const size = screenSize();
  useEffect(() => {}, [size]);
  const classes = useStyles();
  const { data } = useQuery(GET_PRODUCT_INFO, {
    variables: {
      eventId,
    },
  });
  return (
    // <Paper classes={{ root: classes.root }}>
    <ImageList
      // cellHeight={160}
      className={classes.gridList}
      cols={2}
      spacing={15}
    >
      {data?.getProduct?.map(list => {
        return (
          <ImageListItem cols={1} rows={-1} key={list.id}>
            <ProductCard
              assetTypeKey='assetType'
              assetKey='asset'
              compact
              key={list.id}
              onClick={() => router.push(`/products/${encodeURIComponent(list.slug)}`)}
              product={list}
              viewer={viewer}
              className={classes.card}
              min
            />
          </ImageListItem>
        );
      })}
    </ImageList>
    // </Paper>
  );
};

ProductGridView.propTypes = {
  viewer: PropTypes.object.isRequired,
  eventId: PropTypes.number.isRequired,
};

export default ProductGridView;
